import { render, staticRenderFns } from "./Div_salud.vue?vue&type=template&id=2da7ef9c"
import script from "./Div_salud.vue?vue&type=script&lang=js"
export * from "./Div_salud.vue?vue&type=script&lang=js"
import style0 from "./Div_salud.vue?vue&type=style&index=0&id=2da7ef9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports